export default "__VITE_ASSET__BsSLoI87__"